export default __webpack_public_path__ + "images/SS.f2bb70f.png";